// Test data for UserHierarchy development and testing
export const createTestUsers = () => {
  const testUsers = [
    // Owner/CEO
    {
      _id: 'owner-001',
      email: 'ceo@company.com',
      profile_information: {
        name: 'John',
        surname: 'Smith',
        avatar: null
      },
      role: 'CEO',
      department: 'Executive',
      status: 'active'
    },
    // Engineering Department
    {
      _id: 'eng-001',
      email: 'cto@company.com',
      profile_information: {
        name: 'Sarah',
        surname: 'Johnson',
        avatar: null
      },
      role: 'CTO',
      department: 'Engineering',
      status: 'active'
    },
    {
      _id: 'eng-002',
      email: 'dev1@company.com',
      profile_information: {
        name: 'Mike',
        surname: 'Chen',
        avatar: null
      },
      role: 'Senior Developer',
      department: 'Engineering',
      status: 'active'
    },
    {
      _id: 'eng-003',
      email: 'dev2@company.com',
      profile_information: {
        name: 'Emily',
        surname: 'Davis',
        avatar: null
      },
      role: 'Frontend Developer',
      department: 'Engineering',
      status: 'active'
    },
    {
      _id: 'eng-004',
      email: 'dev3@company.com',
      profile_information: {
        name: 'Alex',
        surname: 'Wilson',
        avatar: null
      },
      role: 'Backend Developer',
      department: 'Engineering',
      status: 'active'
    },
    // Sales Department
    {
      _id: 'sales-001',
      email: 'sales-manager@company.com',
      profile_information: {
        name: 'Lisa',
        surname: 'Brown',
        avatar: null
      },
      role: 'Sales Manager',
      department: 'Sales',
      status: 'active'
    },
    {
      _id: 'sales-002',
      email: 'sales1@company.com',
      profile_information: {
        name: 'Tom',
        surname: 'Garcia',
        avatar: null
      },
      role: 'Sales Representative',
      department: 'Sales',
      status: 'active'
    },
    {
      _id: 'sales-003',
      email: 'sales2@company.com',
      profile_information: {
        name: 'Jessica',
        surname: 'Martinez',
        avatar: null
      },
      role: 'Sales Representative',
      department: 'Sales',
      status: 'active'
    },
    // Marketing Department
    {
      _id: 'marketing-001',
      email: 'marketing-manager@company.com',
      profile_information: {
        name: 'David',
        surname: 'Anderson',
        avatar: null
      },
      role: 'Marketing Manager',
      department: 'Marketing',
      status: 'active'
    },
    {
      _id: 'marketing-002',
      email: 'marketing1@company.com',
      profile_information: {
        name: 'Rachel',
        surname: 'Taylor',
        avatar: null
      },
      role: 'Content Creator',
      department: 'Marketing',
      status: 'active'
    },
    // HR Department
    {
      _id: 'hr-001',
      email: 'hr-manager@company.com',
      profile_information: {
        name: 'Jennifer',
        surname: 'White',
        avatar: null
      },
      role: 'HR Manager',
      department: 'Human Resources',
      status: 'active'
    },
    {
      _id: 'hr-002',
      email: 'hr1@company.com',
      profile_information: {
        name: 'Kevin',
        surname: 'Lee',
        avatar: null
      },
      role: 'HR Specialist',
      department: 'Human Resources',
      status: 'active'
    },
    // Pending Users
    {
      _id: 'pending-001',
      email: 'newhire1@company.com',
      profile_information: {
        name: 'New',
        surname: 'Hire',
        avatar: null
      },
      role: 'Junior Developer',
      department: 'Engineering',
      status: 'pending',
      isPending: true,
      invitedAt: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString() // 2 days ago
    },
    {
      _id: 'pending-002',
      email: 'newhire2@company.com',
      profile_information: {
        name: 'Another',
        surname: 'Newbie',
        avatar: null
      },
      role: 'Marketing Assistant',
      department: 'Marketing',
      status: 'pending',
      isPending: true,
      invitedAt: new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).toISOString() // 1 day ago
    }
  ];

  return testUsers;
};

export const createTestDepartments = () => {
  return [
    {
      _id: 'dept-executive',
      department_name: 'Executive',
      description: 'Company leadership and executive team',
      color: '#8b5cf6' // Purple
    },
    {
      _id: 'dept-engineering',
      department_name: 'Engineering',
      description: 'Software development and technical team',
      color: '#06b6d4' // Cyan
    },
    {
      _id: 'dept-sales',
      department_name: 'Sales',
      description: 'Sales and business development',
      color: '#10b981' // Emerald
    },
    {
      _id: 'dept-marketing',
      department_name: 'Marketing',
      description: 'Marketing and brand management',
      color: '#f59e0b' // Amber
    },
    {
      _id: 'dept-hr',
      department_name: 'Human Resources',
      description: 'Human resources and talent management',
      color: '#ef4444' // Red
    }
  ];
};

export const createTestLinks = () => {
  return [
    // CEO connections
    { from: 'owner-001', to: 'eng-001', type: 'manages' },
    { from: 'owner-001', to: 'sales-001', type: 'manages' },
    { from: 'owner-001', to: 'marketing-001', type: 'manages' },
    { from: 'owner-001', to: 'hr-001', type: 'manages' },
    
    // CTO connections
    { from: 'eng-001', to: 'eng-002', type: 'manages' },
    { from: 'eng-001', to: 'eng-003', type: 'manages' },
    { from: 'eng-001', to: 'eng-004', type: 'manages' },
    
    // Sales Manager connections
    { from: 'sales-001', to: 'sales-002', type: 'manages' },
    { from: 'sales-001', to: 'sales-003', type: 'manages' },
    
    // Marketing Manager connections
    { from: 'marketing-001', to: 'marketing-002', type: 'manages' },
    
    // HR Manager connections
    { from: 'hr-001', to: 'hr-002', type: 'manages' },
    
    // Cross-department collaboration
    { from: 'eng-002', to: 'marketing-002', type: 'collaborates' },
    { from: 'sales-002', to: 'hr-002', type: 'collaborates' }
  ];
};

// Department color mapping
export const getDepartmentColor = (departmentName: string) => {
  const colors = {
    'Executive': '#8b5cf6',
    'Engineering': '#06b6d4',
    'Sales': '#10b981',
    'Marketing': '#f59e0b',
    'Human Resources': '#ef4444',
    'Reception': '#6B7280',
    'General': '#8B5CF6',
    'Unassigned': '#9CA3AF'
  };
  return colors[departmentName] || '#6b7280';
};

// Department grouping utilities
export const groupUsersByDepartment = (users: any[]) => {
  console.log('🔍 groupUsersByDepartment input:', {
    usersCount: users?.length,
    users: users?.map(u => ({
      _id: u._id,
      hasUser: !!u.user,
      department: u.department,
      profileDepartment: u.profile_information?.department,
      nestedDepartment: u.user?.profile_information?.department,
      nestedDirectDepartment: u.user?.department
    }))
  });

  const grouped = users.reduce((acc, user) => {
    // Handle both nested user structure (from API) and direct user objects
    // API returns: { user: { profile_information: { department: 'X' } } }
    // Direct user: { department: 'X' } or { profile_information: { department: 'X' } }
    let dept = 'Unassigned';

    if (user.user) {
      // Nested structure from API (company.users or user.connectedUsers)
      // Priority: company.users.department > user.profile_information.department > user.department
      dept = user.department || // ← Company-level department (highest priority)
        user.user.profile_information?.department ||
        user.user.department ||
        'Unassigned';
    } else {
      // Direct user object
      dept = user.department || // ← Company-level department (highest priority)
        user.profile_information?.department ||
        'Unassigned';
    }

    // Ensure users without any department are marked as "Unassigned"
    if (!dept || dept === '' || dept === null || dept === undefined) {
      dept = 'Unassigned';
    }

    console.log('🔍 Processing user for department:', {
      userId: user._id,
      hasUser: !!user.user,
      extractedDepartment: dept,
      userStructure: user.user ? 'nested' : 'direct',
      departmentSource: user.department ? 'company.users.department' :
        (user.user?.profile_information?.department ? 'user.profile_information.department' : 'default'),
      companyDepartment: user.department,
      profileDepartment: user.user?.profile_information?.department
    });

    if (!acc[dept]) {
      acc[dept] = [];
    }

    // Push the actual user object (unwrap if nested)
    acc[dept].push(user.user || user);
    return acc;
  }, {} as Record<string, any[]>);

  console.log('🔍 Department grouping result:', {
    departments: Object.keys(grouped),
    counts: Object.entries(grouped).map(([dept, users]) => ({
      department: dept,
      count: users.length
    }))
  });

  // Sort departments by priority (Executive first, then alphabetically, Unassigned last)
  const priority = ['Executive', 'Engineering', 'Sales', 'Marketing', 'Human Resources', 'Reception'];
  const sortedDepartments = Object.keys(grouped).sort((a, b) => {
    // Unassigned always goes last
    if (a === 'Unassigned') return 1;
    if (b === 'Unassigned') return -1;

    const aIndex = priority.indexOf(a);
    const bIndex = priority.indexOf(b);
    if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
    if (aIndex !== -1) return -1;
    if (bIndex !== -1) return 1;
    return a.localeCompare(b);
  });

  return sortedDepartments.map(dept => ({
    name: dept,
    users: grouped[dept],
    color: getDepartmentColor(dept),
    count: grouped[dept].length
  }));
};
